import { ReactNode } from "react";

interface IProps<NameType extends string> {
  isChecked: boolean;
  onChange: (name: NameType) => void;
  name: string;
  label: ReactNode;
}

const CustomCheckbox = <T extends string>({
  isChecked,
  onChange,
  name,
  label = "By checking this box, you acknowledge the information below",
}: IProps<T>) => (
  <label
    htmlFor={name}
    className="group relative py-3 px-0 flex items-center rounded-md cursor-pointer"
  >
    <div className="custom-checkbox flex">
      <input
        type="checkbox"
        id={name}
        checked={isChecked}
        onChange={() => onChange(name as T)}
        className="w-3.5 sm:w-4 lg:w-5 h-3.5 sm:h-4 lg:h-5 cursor-pointer hidden-checkbox"
      />
      <div className="styled-checkbox" />
    </div>
    <div className="grow">
      <div className="text-base sm:text-lg ml-6 sm:ml-7 lg:ml-8 text-charcoal font-bold">
        {label}
      </div>
    </div>
  </label>
);

export default CustomCheckbox;
